<!-- Primary -->
<ng-container *ngIf="color === 'primary'" >
  <div class="md-input-autocomplete md-input-autocomplete__primary">
    <div class="md-input-autocomplete__input d-flex justify-content-start align-items-center">
      <span class="md-input-autocomplete__span d-flex justify-content-center align-items-center">
        <mat-icon>search</mat-icon>
      </span>
      <input [value]="value" type="text" autocomplete="off" [placeholder]="placeholder">
    </div>
    <div *ngIf="data.length && value.length && isOpen; else emptyPatients">
      <div class="md-input-autocomplete__results" [perfectScrollbar]>
        <ul class="md-input-autocomplete__results__list  list-unstyled m-b-0">
          <ng-container *ngFor="let item of data">
            <li class="clearfix" [class.active]="item.id===selectedItem?.id" (click)="onSelect($event, item)">
              {{item.name}}                
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
    <ng-template #emptyPatients>
      <div class="emptyPatient-content">
  
      </div>
    </ng-template>
  </div>
</ng-container>

<ng-container *ngIf="color === 'primary-stroked'"> 
</ng-container>

<ng-container *ngIf="color === 'primary-text'">

</ng-container>
<ng-container *ngIf="color === 'primary-opacity'">
  
</ng-container>
<!-- Secondary -->
<ng-container  *ngIf="color === 'accent'">
</ng-container>

<ng-container *ngIf="color === 'accent-stroked'">
  
</ng-container>

<ng-container *ngIf="color === 'accent-text'">
  
</ng-container>
<ng-container *ngIf="color === 'accent-opacity'">
  
</ng-container>
<!-- Warn -->
<ng-container *ngIf="color === 'warn'">
</ng-container>

<ng-container *ngIf="color === 'warn-stroked'">
  
</ng-container>

<ng-container *ngIf="color === 'warn-text'">
  
</ng-container>
<ng-container *ngIf="color === 'warn-opacity'">
  
</ng-container>
<ng-template #buttonContent>
  <ng-content></ng-content>
</ng-template>